var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"detail-title"},[_vm._v(_vm._s(_vm.$t('network.text_501')))]),_c('vxe-grid',{attrs:{"data":_vm.listData,"columns":_vm.columns}},[_c('span',{attrs:{"slot":"empty"},slot:"empty"},[_vm._v(_vm._s(_vm.isRedirect ? _vm.$t('network.text_502') : _vm.$t('network.text_503')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }